import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { ProductsHighlightCardLibTracker } from '../tracking/UsageTracker';
export const trackCloneProduct = modifiedPropertyNames => {
  CrmLogger.log('indexInteractions', {
    action: 'create product',
    subaction: 'clone'
  });
  ProductsHighlightCardLibTracker.track('Products Highlight Card', 'Product panel', {
    action: 'Clone product',
    subAction: 'Save',
    propertyName: modifiedPropertyNames
  });
};
export const trackDeleteProduct = () => {
  CrmLogger.log('indexInteractions', {
    action: 'delete product'
  });
  ProductsHighlightCardLibTracker.track('Products Highlight Card', 'deleteObject', {
    action: 'Delete product'
  });
};
export const trackActivateProduct = () => {
  CrmLogger.log('indexInteractions', {
    action: 'activate product'
  });
  ProductsHighlightCardLibTracker.track('Products Highlight Card', 'Product panel', {
    action: 'Activate product'
  });
};
export const trackDeactivateProduct = () => {
  CrmLogger.log('indexInteractions', {
    action: 'deactivate product'
  });
  ProductsHighlightCardLibTracker.track('Products Highlight Card', 'Product panel', {
    action: 'Deactivate product'
  });
};